(() => {
  'use strict';
  if (customElements.get('am-cyber-extended')) return;
  class CyberExtended extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.start());
    }
    start() {
      this.ends = Date.parse(this.dataset.endsAt);
      this.clock = this.querySelector('[data-amx-clock]');
      this.fields = ['days', 'hours', 'minutes', 'seconds'].map(name => this.querySelector('[data-amx-' + name + ']'));
      if (!Number.isFinite(this.ends) || !this.clock || this.fields.some(field => !field)) return;
      this.tick();
      if (Date.now() < this.ends) this.timer = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      clearInterval(this.timer);
    }
    tick() {
      const seconds = Math.max(0, Math.ceil((this.ends - Date.now()) / 1000));
      const values = [Math.floor(seconds / 86400), Math.floor(seconds % 86400 / 3600), Math.floor(seconds % 3600 / 60), seconds % 60];
      this.fields.forEach((field, i) => {
        const value = String(values[i]).padStart(2, '0');
        if (field.textContent !== value) field.textContent = value;
      });
      this.clock.setAttribute('aria-label', 'Cyber ALTO MATE Extendido termina en ' + values[0] + ' días, ' + values[1] + ' horas y ' + values[2] + ' minutos. Hasta el 11 de noviembre a las 23:59, hora argentina.');
      if (seconds === 0) {
        clearInterval(this.timer);
        this.querySelector('[data-amx-countdown]').hidden = true;
        this.querySelector('[data-amx-ended]').hidden = false;
      }
    }
  }
  customElements.define('am-cyber-extended', CyberExtended);
})();
